import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getPermissionKeyValue from '../../services/permission/getPermissionKeyValue'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchPermissionComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchPermissionKeyValue () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const permissionCombo = yield call(getPermissionKeyValue, auth.token)
    yield put(fetchPermissionComboSuccess({ data: permissionCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchPermissionKeyValue () {
  yield takeLatest(combosActionTypes.FETCH_PERMISSION_KEY_VALUE, fetchPermissionKeyValue)
}
